import { render, staticRenderFns } from "./DataTable3.vue?vue&type=template&id=73c10e93&scoped=true"
import script from "./DataTable3.vue?vue&type=script&lang=js"
export * from "./DataTable3.vue?vue&type=script&lang=js"
import style0 from "./DataTable3.vue?vue&type=style&index=0&id=73c10e93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c10e93",
  null
  
)

export default component.exports